module.exports = __webpack_public_path__ + "assets/b17.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b17.png
// module id = 602
// module chunks = 0